export const infoPageLayoutByVariant = {
  desktop: {
    pb: 124,
    pt: 100,
    px: 150,
    subtitleVariant: 'MS-semiregular-s16-lh21',
    titleVariant: 'BN-bold-s123-lh104',
  },
  laptop: {
    pb: 124,
    pt: 100,
    px: 16,
    subtitleVariant: 'MS-semiregular-s16-lh21',
    titleVariant: 'BN-bold-s123-lh104',
  },
  mobile: {
    pb: 124,
    pt: 100,
    px: 16,
    subtitleVariant: 'MS-semiregular-s16-lh21',
    titleVariant: 'BN-bold-s80-lh84',
  },
  tablet: {
    pb: 124,
    pt: 100,
    px: 16,
    subtitleVariant: 'MS-semiregular-s16-lh21',
    titleVariant: 'BN-bold-s123-lh104',
  },
};
